// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay[data-v-cf338a46]{width:100%;height:100%;position:absolute;top:0;left:0;background-color:var(--overlay-bg);z-index:1}.ui-perf-setting P[data-v-cf338a46]{line-height:1.25;margin-bottom:10px}.ui-perf-setting .underline[data-v-cf338a46]{text-decoration:underline}.input[data-v-cf338a46]{max-width:25%}", ""]);
// Exports
module.exports = exports;
